import React from "react"

import { FeatureFlag } from "@common-shared/config/featureFlags.config"

import { MENU_CONFIG } from "../../config/menu.config"
import { ScreenTabsLayoutElement } from "../../elements/screenTabsLayout.element"
import { useIsFeatureFlagEnabled } from "../../hooks/isFeatureFlagEnabled.hook"
import { PayerMappingsComponent } from "./payerMappings/payerMappings.component"
import { PayerRatesComponent } from "./payerRates/payerRates.component"

export const ConfigurationsComponent: React.FunctionComponent = () => {
    // TODO: Remove this once we remove the early release feature flag for configurations page
    useIsFeatureFlagEnabled(FeatureFlag.ONE_VERIFY_EARLY_RELEASE_FEATURES)

    return (
        <ScreenTabsLayoutElement
            tabs={MENU_CONFIG.configurationsAvailableTabs}
            renderTabContent={tab => {
                switch (tab.key) {
                    case "payer_rates":
                        return <PayerRatesComponent />

                    case "payer_mappings":
                        return <PayerMappingsComponent />

                    default:
                        return null
                }
            }}
        />
    )
}
